import { render, staticRenderFns } from "./slots-blockchain.vue?vue&type=template&id=0a1d5798&scoped=true&"
import script from "./slots-blockchain.vue?vue&type=script&lang=js&"
export * from "./slots-blockchain.vue?vue&type=script&lang=js&"
import style0 from "./slots-blockchain.vue?vue&type=style&index=0&id=0a1d5798&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1d5798",
  null
  
)

export default component.exports